<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.attentions')"
      >Volver a Atenciones</back-profile
    >

    <ul style="padding-inline-start: 0px;">
      <li v-for="studentAttention in groupOfAttentions" :key="studentAttention.id">
        <block :bordered-header="true" style="padding-bottom: 60px; margin: 10px 0;">
          <template slot="header">{{ attentionTitle(studentAttention) }}</template>
          <template slot="subheader">{{ attentionStatus(studentAttention) }}</template>

          <div class="meta-list">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Registrado por:</span>
              <span class="meta-value">{{ studentAttention.creator.name }}</span>
              ({{ studentAttention.createdAt | formatStandardDate }})
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Responsable asignado:</span>
              <span class="meta-value">{{ studentAttention.responsible.name }}</span>
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Fecha límite asignada:</span>
              <span class="meta-value">{{ studentAttention.dueBy | formatStandardDate }}</span>
            </div>

            <hr />

            <div
              v-if="
                studentAttention.participationOf && studentAttention.participationOf.comment.comment
              "
              class="meta-item"
            >
              <span class="meta-name has-text-weight-bold">Resultado:</span>
              <span class="meta-value">{{ studentAttention.participationOf.comment.comment }}</span>
            </div>
            <div
              v-if="
                studentAttention.status !== 'FAILED' &&
                  studentAttention.participationOf &&
                  studentAttention.participationOf['evaluation']
              "
              class="meta-item"
            >
              <span class="meta-name has-text-weight-bold">Evaluación:</span>
              <span class="meta-value">
                <button class="emotion">
                  {{ evaluationIconScore[studentAttention.participationOf["evaluation"]] }}
                </button>
              </span>
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Fecha de cierre:</span>
              <span class="meta-value">
                {{ studentAttention.performedAt | formatStandardDate }}
              </span>
            </div>
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Responsable de cierre:</span>
              <span class="meta-value">{{ finishedByUser(studentAttention) }}</span>
            </div>
          </div>
          <div class="description">
            <i></i>
          </div>

          <div v-if="!studentAttention.isDone" class="actions">
            <button class="button is-primary" @click="finishAttention">Finalizar</button>
          </div>
        </block>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment"
import STUDENT_ATTENTION_DETAIL from "./graphql/StudentAttention.gql"
import STUDENT_ATTENTIONS from "./graphql/StudentAttentions.gql"
import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"

export default {
  name: "ProfileAttention",
  props: {
    attentionId: {
      type: String
    },
    studentId: {
      type: String
    }
  },
  data() {
    return {
      studentAttention: {
        creator: {
          name: ""
        },
        action: {
          hidden: false,
          plan: {
            hidden: false,
            category: {}
          }
        },
        responsible: {
          name: ""
        }
      },
      evaluationIconScore: { YAY: ":)", MEH: ":|", SAD: ":(" },
      studentAttentions: []
    }
  },
  computed: {
    groupOfAttentions() {
      let action = this.studentAttention.action
      let attentions = []

      this.studentAttentions.map(attention => {
        if (attention.action.id === action.id) {
          attentions.push(attention)
        }
      })

      return attentions
    }
  },
  apollo: {
    studentAttention: {
      query: STUDENT_ATTENTION_DETAIL,
      variables() {
        return {
          attentionId: this.attentionId,
          studentId: this.studentId
        }
      }
    },
    studentAttentions: {
      query: STUDENT_ATTENTIONS,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },
  methods: {
    navigateTo(route) {
      this.$emit("hello", route)
    },
    finishedByUser(studentAttention) {
      if (studentAttention.finishedBy) {
        return studentAttention.finishedBy.name
      } else {
        return "-"
      }
    },
    attentionTitle(item) {
      let title = item.action.plan.category.name
      if (!item.action.plan.hidden) title += " - " + item.action.plan.name
      if (!item.action.hidden) title += " - " + item.action.name
      return title
    },
    attentionStatus(attention) {
      let status
      if (attention.status == "PENDING") status = "pendiente"
      if (attention.status == "COMPLETED") status = "realizada"
      if (attention.status == "FAILED") status = "fallida"
      return status
    },
    finishAttention() {
      this.navigateTo({
        state: "app.profile.finish_attention",
        params: {
          attentionId: this.attentionId
        }
      })
    },
    deleteAttention() {
      this.navigateTo({
        state: "app.profile.delete_attention",
        params: {
          attentionId: this.attentionId
        }
      })
    }
  },
  components: {
    Block,
    BackProfile
  },
  filters: {
    humanizeDate(date) {
      if (date === null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    },
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date).format("DD/MM/YYYY")
      }
    }
  }
}
</script>

<style scoped>
.meta-list {
  margin-bottom: 30px;
}
.meta-item {
  margin-bottom: 10px;
}

.description {
  margin-bottom: 20px;
}

.emotion {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transform: rotate(90deg);
  font-size: 18px;
  line-height: 18px;
  width: 30px;
  height: 30px;
  pointer-events: none;
}
li {
  list-style-type: none;
}
</style>
